import React, { useEffect, useState, useContext } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import "./IconPicker.scss";
import OutsideClickHandler from "react-outside-click-handler";
import { fontAwesomeIcons } from "../../masterData";

function IconPicker(props) {
  const handleClose = () => {
    props.hideIconPicker();
  };
  const handleSelectIcon = (icon) => {
    props.handleIconSelect(props.index, icon);
  };
  return (
    <OutsideClickHandler
      onOutsideClick={(e, value) => {
        const parentWithClass = e.target.closest(".icon-picker");
        if (props && props.showIconPicker && parentWithClass == null) {
          handleClose();
        }
      }}
    >
      <div className="icon-picker bg-gray ">
        <div className="icon-picker-inner-div">
          <span className="icon-picker-close" onClick={() => handleClose()}>
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>

          <Scrollbars style={{ height: "280px" }}>
            <div className="icon-picker-div-visual d-flex flex-wrap mt-4">
              {fontAwesomeIcons &&
                fontAwesomeIcons.map((item) => (
                  <>
                    <div className="col-md-2 p-2">
                      <i
                        class={`${item} mr-2`}
                        aria-hidden="true"
                        onClick={() => handleSelectIcon(item)}
                      ></i>
                    </div>
                  </>
                ))}
            </div>
          </Scrollbars>
        </div>
      </div>
    </OutsideClickHandler>
  );
}

export default IconPicker;
